import { Component, OnInit } from '@angular/core';
import { AuthProcessService } from 'ngx-auth-firebaseui';
import { User } from '@firebase/auth-types';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor(public authService: AuthProcessService, private router: Router) {

  }

  ngOnInit() {


  }

  logout() {
    this.authService.signOut();
    this.router.navigate(['/login']);
    
  }

}
